var _line, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 195,
    viewBox: "0 0 7 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 17.5,
    x2: 3.5,
    y2: 32.5,
    stroke: "#ABFF29",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0.833333C2.02724 0.833333 0.833333 2.02724 0.833333 3.5C0.833333 4.97276 2.02724 6.16667 3.5 6.16667C4.97276 6.16667 6.16667 4.97276 6.16667 3.5C6.16667 2.02724 4.97276 0.833333 3.5 0.833333ZM3 12.5C3 12.7761 3.22386 13 3.5 13C3.77614 13 4 12.7761 4 12.5L3 12.5ZM3 3.5L3 12.5L4 12.5L4 3.5L3 3.5Z",
    fill: "#ABFF29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50001 188.833C2.02725 188.833 0.83334 190.027 0.83334 191.5C0.83334 192.973 2.02725 194.167 3.50001 194.167C4.97277 194.167 6.16667 192.973 6.16667 191.5C6.16667 190.027 4.97277 188.833 3.50001 188.833ZM3 36.5L3.00001 191.5L4.00001 191.5L4 36.5L3 36.5Z",
    fill: "#ABFF29"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashLine);
export default __webpack_public_path__ + "static/media/dashLine.ab4c11454d4122ac7960e524a1b470ef.svg";
export { ForwardRef as ReactComponent };